import ToggleControl from './ToggleControl';
import SettingsCard from './SettingsCard';

const NotificationsSection = ({ data, states, onToggle }) => {
  const { title, description, items } = data;

  return (
    <SettingsCard title={title} description={description}>
      <div className="space-y-4">
        {items.map((item) => (
          <ToggleControl
            key={item.id}
            label={item.label}
            description={item.description}
            checked={!!states[item.id]}
            onChange={(value) => onToggle(item.id, value)}
          />
        ))}
      </div>
    </SettingsCard>
  );
};

export default NotificationsSection;
